<mat-card>
    <mat-card-header>
        <mat-card-title>{{ 'Attachments' }}</mat-card-title>
        <button mat-flat-button linkButton disableRipple
                [disabled]="loadingInitialData"
                (click)="addFiles()">
            {{ 'Add Files' }}
        </button>
    </mat-card-header>

    <mat-progress-bar mode="query" color="primary" [class.active]="!addAttachmentsEnabled && formGroup.get('id').value">
    </mat-progress-bar>

    <mat-divider></mat-divider>

    <mat-card-content>
        <mat-list class="attachments-actions">
            <app-empty-state *ngIf="!loadingInitialData && attachments?.length === 0" align="left">
                <span emptyStateText>{{ 'No attachments added' }}</span>
            </app-empty-state>

            <mat-list-item *ngIf="!attachments">
                <app-avatar-block [isLoadingInitialData]="loadingInitialData">
                </app-avatar-block>
            </mat-list-item>

            <ng-container *ngFor="let attachment of attachments">
                <mat-list-item [class.deleting]="!addAttachmentsEnabled && formGroup.get('id').value === attachment.id">
                    <ng-template #attachmentName>
                        <app-avatar-block [svgIcon]="getSvgIcon(attachment)">{{ attachment.fileName }}</app-avatar-block>
                    </ng-template>

                    <a *ngIf="attachment.viewUrl; else attachmentName"
                       target="_blank"
                       [id]="attachment.id"
                       [href]="attachment.viewUrl"
                       mat-flat-button linkButton disableRipple>
                        <app-avatar-block [svgIcon]="getSvgIcon(attachment)">{{ attachment.fileName }}</app-avatar-block>
                    </a>

                    <mat-toolbar>
                        <flex-spacer></flex-spacer>
                        <a *ngIf="attachment.viewUrl"
                           mat-flat-button disableRipple color="accent"
                           href="{{ attachment.viewUrl }}" target="_blank">
                            <mat-icon [svgIcon]="'v2:fi-br-eye'"></mat-icon>
                        </a>
                        <button mat-flat-button disableRipple color="accent"
                                (click)="deleteAttachment(attachment)">
                            <mat-icon [svgIcon]="'v2:fi-br-trash'"></mat-icon>
                        </button>
                        <a *ngIf="attachment.downloadUrl"
                           mat-flat-button disableRipple color="accent"
                           href="{{ attachment.downloadUrl }}">
                            <mat-icon [svgIcon]="'v2:fi-br-download'"></mat-icon>
                        </a>
                    </mat-toolbar>
                </mat-list-item>
            </ng-container>
        </mat-list>
    </mat-card-content>
</mat-card>
